import { PlausibleTracker } from './trackers/PlausibleTracker';
import { GtagTracker } from './trackers/GtagTracker';
import { Tracker, TrackingEvent, TrackerLogger } from './Tracking.events';
import { MetaPixelTracker } from './trackers/MetaPixelTracker';
import { MatomoTracker } from './trackers/MatomoTracker';
import { TiktokPixelTracker } from './trackers/TiktokPixelTracker';

export class Trackers implements Tracker {
	gtag: Tracker | null = null;
	gtm: Tracker | null = null;
	matomo: Tracker | null = null;
	plausible: Tracker | null = null;
	metaPixel: Tracker | null = null;
	tikTokPixel: Tracker | null = null

	constructor(args: TrackersArgs) {
		const { gtag, plausible, metaPixel, matomo, tiktokPixel } = args;
		console.log(`TRACKERS: `, args);

		if (gtag) {
			this.gtag = new GtagTracker();
		}

		if (plausible) {
			this.plausible = new PlausibleTracker(plausible);
		}

		if (metaPixel) {
			this.metaPixel = new MetaPixelTracker(metaPixel);
		}

		if (tiktokPixel) {
			this.metaPixel = new TiktokPixelTracker(tiktokPixel);
		}

		if (matomo) {
			this.matomo = new MatomoTracker(matomo);
		}
	}
	sendEvent(event: TrackingEvent) {
		TrackerLogger.debug(`Event:`, event);
		if (this.gtag) {
			this.gtag.sendEvent(event);
		}
		if (this.gtm) {
			this.gtm.sendEvent(event);
		}
		if (this.matomo) {
			this.matomo.sendEvent(event);
		}
		if (this.plausible) {
			this.plausible.sendEvent(event);
		}
		if (this.metaPixel) {
			this.metaPixel.sendEvent(event);
		}
	}
}

interface TrackersArgs {
	gtag?: any;
	gtm?: any;
	matomo?: any;
	plausible?: any;
	metaPixel?: any;
	tiktokPixel?: any;
}
